<script setup>
import { computed } from 'vue';

const props = defineProps({
  stepLabel: { type: String, default: '' },
  title: { type: String, default: '' },
  description: { type: String, default: '' },
  wide: { type: Boolean, default: false },
  extraWide: { type: Boolean, default: false },
  fullWidth: { type: Boolean, default: false },
  hideHeader: { type: Boolean, default: false },
});

const showHeader = computed(
  () =>
    !props.hideHeader &&
    Boolean(props.stepLabel || props.title || props.description)
);

const widthClass = computed(() => {
  if (props.fullWidth) return 'max-w-none';
  if (props.extraWide) return 'max-w-6xl';
  if (props.wide) return 'max-w-4xl';
  return 'max-w-2xl';
});
</script>

<template>
  <section class="w-full flex flex-col gap-8" :class="widthClass">
    <header v-if="showHeader" class="text-left flex flex-col gap-2">
      <p
        v-if="stepLabel"
        class="m-0 text-sm font-semibold text-slate-500 dark:text-slate-400"
      >
        {{ stepLabel }}
      </p>
      <h1
        v-if="title"
        class="m-0 text-3xl font-bold tracking-tight text-slate-900 dark:text-white"
      >
        {{ title }}
      </h1>
      <p
        v-if="description"
        class="m-0 text-base text-slate-500 dark:text-slate-400"
      >
        {{ description }}
      </p>
      <slot name="header-extra" />
    </header>

    <div class="w-full">
      <slot />
    </div>
  </section>
</template>
